import React, {Component} from 'react';
import axios from 'axios';
import {checkIfDesktop, getCookie, setCookie} from '../../utils';
import ProductsList from './ProductsList';
import CategoriesSidebar from './CategoriesSidebar';
import OptionsBar from './OptionsBar';
import PaginationList from './PaginationList';

export default class ProductsListingRoot extends Component {
    constructor(props) {
        super(props);

        const
            layoutTypeFromCookies = getCookie('layoutType'),
            initialLayoutType = layoutTypeFromCookies ? layoutTypeFromCookies : ProductsList.layoutTypes.list,
            itemsPerPageFromCookies = getCookie('itemsPerPage'),
            initialItemsPerPage = itemsPerPageFromCookies ? itemsPerPageFromCookies : OptionsBar.itemsQuantities[0];

        this.state = {
            searchTerm: this.props.searchTerm,
            categoryId: this.props.categoryId,
            itemsPerPage: initialItemsPerPage,
            layoutType: initialLayoutType,
            isLoading: true,
            isInitialRender: true,
            activeCategory: '',
            productsList: [],
            subcategoriesList: [],
            currentPageNumber: 1,
            numberOfPages: 0
        };

        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
        this.handleItemsQuantityChange = this.handleItemsQuantityChange.bind(this);
        this.handleLayoutChange = this.handleLayoutChange.bind(this);
        this.setActiveCategory = this.setActiveCategory.bind(this);
    }

    componentDidMount() {
        this.fetchData();

        if (!checkIfDesktop()) {
            this.setState({layoutType: ProductsList.layoutTypes.grid});
        }
    }

    fetchData() {
        this.setState({isLoading: true});

        const {
            categoryId,
            currentPageNumber,
            itemsPerPage,
            searchTerm,
            activeCategory
        } = this.state;

        const params = {
            categoryId: categoryId,
            pageNo: currentPageNumber,
            itemsPerPage: itemsPerPage,
            term: searchTerm,
            categoryFacet: activeCategory
        };

        axios.get(this.props.rootUrl, {params})
            .then(result => {
                const
                    productsList = result.data.Results,
                    numberOfPages = result.data.TotalPages,
                    subcategoriesList = result.data.Categories;

                this.setState({
                    productsList,
                    numberOfPages
                });

                if (this.state.isInitialRender) {
                    this.setState({
                        subcategoriesList,
                        isInitialRender: false
                    }, this.setActiveCategory);
                }
            })
            .then(() => this.setState({isLoading: false}))
            .catch( (error) => {
                this.setState({isLoading: false});
                this.handleFetchError(error);
            });
    }

    setActiveCategory() {
        const {subcategoriesList} = this.state;

        if (subcategoriesList.length === 1) {
            this.setState({activeCategory: subcategoriesList[0].Term})
        }
    }

    handleFetchError(error) {
        if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
        } else if (error.request) {
            console.log(error.request);
        } else {
            console.log('Error', error.message);
        }
        console.log(error.config);
    }

    handleCategoryChange(e, category) {
        e.preventDefault();

        // When user clicks "All" which represents main category
        if (category === this.state.categoryId) {
            this.setState({
                    activeCategory: '',
                    currentPageNumber: 1
                },
                () => this.fetchData()
            );
        } else {
            this.setState({
                    activeCategory: category,
                    currentPageNumber: 1
                },
                () => this.fetchData()
            );
        }
    }

    handleItemsQuantityChange(quantity) {
        this.setState({
                currentPageNumber: 1,
                itemsPerPage: quantity
            },
            () => this.fetchData()
        );

        setCookie('itemsPerPage', quantity, 30, '/product-catalogue/');
    }

    handleLayoutChange(e, layoutType) {
        e.preventDefault();

        this.setState({layoutType});

        setCookie('layoutType', layoutType, 30, '/product-catalogue/' );
    }

    handlePageChange(pageNumber) {
        this.setState(
            {currentPageNumber: pageNumber},
            () => this.fetchData()
        );
    }

    handlePrev() {
        this.setState((prevState) => ({
            currentPageNumber: prevState.currentPageNumber - 1
        }), () => this.fetchData())
    }

    handleNext() {
        this.setState((prevState) => ({
            currentPageNumber: prevState.currentPageNumber + 1
        }), () => this.fetchData())
    }


    render() {
        const {
            productsList,
            subcategoriesList,
            activeCategory,
            categoryId,
            isLoading,
            layoutType,
            itemsPerPage,
            numberOfPages,
            currentPageNumber
        } = this.state;


        if ((productsList.length === 0 && isLoading === false)) {
            return <h2 className="intro">No results</h2>;
        }

        if (productsList.length > 0) {
            return (
                <div className="row">
                    <aside className="column secondary">
                        <CategoriesSidebar subcategoriesList={subcategoriesList}
                                           onCategoryChange={this.handleCategoryChange}
                                           activeCategory={activeCategory}
                                           categoryId={categoryId}
                        />
                    </aside>
                    <section className="search-results">
                        <OptionsBar
                            onItemsQuantityChange={this.handleItemsQuantityChange}
                            onLayoutChange={this.handleLayoutChange}
                            layoutType={layoutType}
                            itemsPerPage={itemsPerPage}
                        />
                        <ProductsList
                            productsList={productsList}
                            isLoading={isLoading}
                            layoutType={layoutType}
                        />
                        <PaginationList
                            numberOfPages={numberOfPages}
                            currentPageNumber={currentPageNumber}
                            onPageChange={this.handlePageChange}
                            onPrev={this.handlePrev}
                            onNext={this.handleNext}
                        />
                    </section>
                </div>
            )
        } else {
            return (
                    <div className="loader">
                        <p className="visually-hidden-accessible">Loading in progress.</p>
                        <div className="loader__icon"/>
                    </div>
            )
        }
    }
}